define('NavigationHelper.Plugins.Modals.Fix', [
    'NavigationHelper.Plugins.Modals',

    'underscore'
],
function NavigationHelperPluginsModalsFix(
    NavigationHelperPluginsModals,

    _
) {
    'use strict';

    NavigationHelperPluginsModals.showInternalLinkInModal = _(NavigationHelperPluginsModals.showInternalLinkInModal).wrap(
        function showInternalLinkInModal(fn, e, href, $target, layout) {
            var originalShowContent = layout.showContent;
            var result = fn.apply(this, _.toArray(arguments).slice(1));

            layout.originalShowContent = originalShowContent;

            return result;
        }
    );
});

